import * as React from 'react';
import { SubscriptionPlanDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { SubscriptionPlanCancelButtonCSSStyleImpl } from './upgradepackcancelbuttoncss';
import { LoaderWrapperComponent } from '../loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import "./upgradeplan-style.css";
import { UpgradePackComponentHandler, UpgradePackComponentProps, UpgradePackComponentState } from './upgradepackcomponent';
import { UpgradePackCSSStyle } from './upgradepackcss';

export class UpgradePackViewImpl extends UIComponentViewImpl<SubscriptionPlanDetailsDto>
{
    private loaderWrapperComponent:LoaderWrapperComponent;
    bindHandlers()
    {   
        this.onUpgradePackHovered = this.onUpgradePackHovered.bind(this);
        this.onUpgradePackHoveredExit = this.onUpgradePackHoveredExit.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onUpgradePackSelected = this.onUpgradePackSelected.bind(this);

    }

    draw(props: UpgradePackComponentProps, state: UpgradePackComponentState, cssStyle: UpgradePackCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
              <div id="upgradepack-web-wrapper">
                  {
                      this.getWebView(props, state, cssStyle)
                  }
              </div>
              <div id="upgradepack-mobile-wrapper">
                  {
                      this.getMobileView(props, state, cssStyle)
                  }
              </div>
              <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
           
        );
    }

    getWebView(props: UpgradePackComponentProps, state: UpgradePackComponentState, cssStyle: UpgradePackCSSStyle):JSX.Element
    {
        return(
            <>
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label style={cssStyle.getTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.choose_your_subscription_plan)}</label>
                    <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCancelClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                        
                </div>
                <div style={{width:'100%',marginTop:'20px',height:'19px',lineHeight:'19px',textAlign:"center"}}>
                    <label style={{width:'100%',height:'100%',lineHeight:'100%',fontSize:'14px',color:'#898989'}}>
                            {this.getContext().getResources().getString(Strings.you_should_subscribe_a_plan_before_you_buy_gift)}
                    </label>
                </div>

                <div style={{width:'100%',height:'19px',lineHeight:'19px',textAlign:"center"}}>
                    <label style={{width:'100%',height:'100%',lineHeight:'100%',fontSize:'14px',color:'#898989'}}>
                        
                    {this.getContext().getResources().getString(Strings.what_is_subscription)}
                </label>
                </div>
                <div style={{width:'100%',display:'flex',height:'158px',margin:'20px 0px 50px 0px',justifyContent:"center"}}>
                       
                       
                       
                        <div onClick={(e)=>this.onUpgradePackSelected(this.getContext().getConfigurationSettings().getProperty("CRBT_VIP_OFFER_CODE"))} onMouseEnter={this.onUpgradePackHovered} onMouseLeave={this.onUpgradePackHoveredExit} style={cssStyle.getSubscriptionCircleDivCSSStyle((state.onPackselected === this.getContext().getConfigurationSettings().getProperty("CRBT_DAILY_OFFER_CODE")) ? true : state.isUpgradePackHovered)}>
                        <div style={cssStyle.getSubscriptionDetailsDivCSSStyle()}>
                                <label style={{width:'100%',height:'100%', cursor: "pointer",lineHeight:'100%'}}>
                                    {this.getContext().getResources().getString(Strings.vip_charge)}   
                                </label>
                            </div>  
                            <div style={{width:'100%',height:'17px', cursor: "pointer",textAlign:'center',fontSize:'14px',lineHeight:'17px'}}>
                                {this.getContext().getResources().getString(Strings.vip_pack)}
                            </div>
                        </div>
                </div>
                <div style={{width:'100%',height:'40px',marginLeft:'100px',marginRight:'auto',display:'flex'}}>
                            <div style={{width:'180px',height:'40px'}}>
                                <ButtonComponent onClick={this.onCancelClick} style={new SubscriptionPlanCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                            </div>
                            <div style={{width:'180px',height:'40px',marginLeft:'20px'}}>
                                <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                            </div>
                    </div>
                    <div style={cssStyle.getRowDivCSSStyle()}>
                                    <div style={cssStyle.getTermsConditionCSSStyle()}>
                                    <a style={cssStyle.getAnchorCSSStyle()} target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("TND")}>
                                            {props.context.getResources().getString(Strings.terms_condition)}

                                    </a>
                                    </div>
                    </div>  
            </div>
            </>
        );
    }

    getMobileView(props: UpgradePackComponentProps, state: UpgradePackComponentState, cssStyle: UpgradePackCSSStyle):JSX.Element
    {
        return(
            <>
            <div style={cssStyle.getMobileWrapperCSSStyle()}>
                <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label style={cssStyle.getMobileTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.subscription_plan)}</label>
                    <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCancelClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                        
                </div>
                <div style={{width:'100%',marginTop:'20px',height:'19px',lineHeight:'19px',textAlign:"center"}}>
                    <label style={{width:'100%',height:'100%',lineHeight:'100%',fontSize:'12px',color:'#898989'}}>
                            {this.getContext().getResources().getString(Strings.you_should_subscribe_a_plan_before_you_buy_gift)}
                    </label>
                </div>

                <div style={{width:'100%',height:'19px',lineHeight:'19px',textAlign:"center"}}>
                    <label style={{width:'100%',height:'100%',lineHeight:'100%',fontSize:'14px',color:'#898989'}}>
                        
                    {this.getContext().getResources().getString(Strings.what_is_subscription)}
                </label>
                </div>
                <div style={{width:'100%',display:'flex',height:'158px',justifyContent:"center", margin:'20px 7px 7px 7px'}}>
                        {/* <div onClick={(e)=>this.onMonthlyPackSelected("CRBT_MONTHLY")} onMouseEnter={this.onMonthlyHovered} onMouseLeave={this.onMonthlyHoveredExit} style={cssStyle.getMobileSubscriptionCircleDivCSSStyle((state.onPackselected === "CRBT_MONTHLY") ? true : state.isMonthlyHovered)}>
                            <div style={cssStyle.getMobileSubscriptionDetailsDivCSSStyle()}>
                                <label style={{width:'100%',height:'100%', cursor: "pointer", lineHeight:'100%'}}>
                                    {this.getContext().getResources().getString(Strings.monthly_charge)}   
                                </label>
                            </div>     
                                    
                            <div style={{width:'100%',height:'15px',fontSize:'12px', cursor: "pointer", textAlign:'center',lineHeight:'15px'}}>
                                {this.getContext().getResources().getString(Strings.monthly_pack)}
                            </div>
                        </div> */}
                        {/* <div onClick={(e)=>this.onWeeklyPackSelected("CRBT_WEEKLY")} onMouseEnter={this.onWeeklyHovered} onMouseLeave={this.onWeeklyHoveredExit} style={cssStyle.getMobileSubscriptionCircleDivCSSStyle((state.onPackselected === "CRBT_WEEKLY") ? true : state.isWeeklyHovered)}>
                        <div style={cssStyle.getMobileSubscriptionDetailsDivCSSStyle()}>
                                <label style={{width:'100%',height:'100%',lineHeight:'100%',  cursor: "pointer"}}>
                                    {this.getContext().getResources().getString(Strings.weekly_charge)}   
                                </label>
                            </div>  
                            <div style={{width:'100%',height:'15px',textAlign:'center', cursor: "pointer",fontSize:'12px',lineHeight:'15px'}}>
                                {this.getContext().getResources().getString(Strings.weekly_pack)}
                            </div>
                        </div> */}
                        <div onClick={(e)=>this.onUpgradePackSelected(this.getContext().getConfigurationSettings().getProperty("CRBT_VIP_OFFER_CODE"))} onMouseEnter={this.onUpgradePackHovered} onMouseLeave={this.onUpgradePackHoveredExit} style={cssStyle.getMobileSubscriptionCircleDivCSSStyle((state.onPackselected === "CRBT_DAILY") ? true : state.isUpgradePackHovered)}>
                        <div style={cssStyle.getMobileSubscriptionDetailsDivCSSStyle()}>
                                <label style={{width:'100%',height:'100%', cursor: "pointer",lineHeight:'100%'}}>
                                    {this.getContext().getResources().getString(Strings.vip_charge)}   
                                </label>
                            </div>  
                            <div style={{width:'100%',height:'15px', cursor: "pointer",textAlign:'center',fontSize:'12px',lineHeight:'15px'}}>
                                {this.getContext().getResources().getString(Strings.vip_pack)}
                            </div>
                        </div>
                </div>
                <div style={{width:'100%',height:'40px',marginLeft:'0px',justifyContent:"center",marginRight:'auto',display:'flex'}}>
                            <div style={{width:'110px',height:'40px'}}>
                                <ButtonComponent onClick={this.onCancelClick} style={new SubscriptionPlanCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                            </div>
                            <div style={{width:'110px',height:'40px',marginLeft:'20px'}}>
                                <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                            </div>
                    </div>

                    <div style={cssStyle.getRowDivCSSStyle()}>
                                    <div style={cssStyle.getTermsConditionCSSStyle()}>
                                    <a style={cssStyle.getAnchorCSSStyle()} target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("TND")}>
                                            {props.context.getResources().getString(Strings.terms_condition)}

                                    </a>
                                    </div>
                    </div>  
            </div>
            </>
        );
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
 
   
    onUpgradePackSelected(packName:string):void
    {
        (this.getUIComponentHandler() as UpgradePackComponentHandler).onClick(packName);

    }

    onCancelClick():void
    {
        (this.getUIComponentHandler() as UpgradePackComponentHandler).onCancelClick();
    }

    onConfirmClick():void
    {
        (this.getUIComponentHandler() as UpgradePackComponentHandler).onConfirmClick();
    }
   
    private onUpgradePackHovered()
    {
        (this.getUIComponentHandler() as UpgradePackComponentHandler ).onUpgradePackHovered(false,false,true);
    }
  

    private onUpgradePackHoveredExit()
    {
        (this.getUIComponentHandler() as UpgradePackComponentHandler).onUpgradePackHoveredExit();
    }
    

 

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/upgrade_pack/upgradepackview.tsx